import React, { useCallback, useState } from 'react';
import {
  ATMHeader,
  ATMSegment,
  ATMGrid,
  ATMForm,
  ATMField,
  ATMRadio,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';
import { INewFireDispatchMethods } from 'src/models/fire-fighting-dispatch.model';
import style from './fire-dispatch-status-form.module.scss';

type IProps = INewFireDispatchMethods;

const FireDispatchStatusForm: React.FC<IProps> = ({ control }) => {
  const [dispatchStatusValue, setDispatchStatusValue] = useState<
    string | undefined | null
  >(control.defaultValuesRef?.current?.status);
  const handleStatus = useCallback(
    (value) => {
      control.setValue('status', value);
      setDispatchStatusValue(value);
    },
    [control, setDispatchStatusValue]
  );
  return (
    <ATMSegment>
      <div className={style.header}>
        <ATMHeader>{Lang.TTL_FIRE_DISPATCH_FIRE_DISPATCH_STATUS}</ATMHeader>
      </div>
      <ATMGrid columns={1}>
        <ATMGrid.Row>
          <ATMGrid.Column>
            <LabelRequired>{Lang.LBL_FIRE_DISPATCH_STATUS}</LabelRequired>
            <ATMForm.Group style={{ flexDirection: 'column' }}>
              <ATMField
                name="status"
                className="hidden"
                as={ATMForm.Input}
                control={control}
                type="hidden"
              />
              <ATMForm.Field>
                <ATMRadio
                  label={Lang.LBL_FIRE_DISPATCH_STATUS_DISPATCHED}
                  value={Lang.LBL_FIRE_DISPATCH_STATUS_DISPATCHED}
                  checked={
                    dispatchStatusValue ===
                    Lang.LBL_FIRE_DISPATCH_STATUS_DISPATCHED
                  }
                  onChange={() =>
                    handleStatus(Lang.LBL_FIRE_DISPATCH_STATUS_DISPATCHED)
                  }
                />
              </ATMForm.Field>
              <ATMForm.Field>
                <ATMRadio
                  label={Lang.LBL_FIRE_DISPATCH_STATUS_IN_FLIGHT}
                  value={Lang.LBL_FIRE_DISPATCH_STATUS_IN_FLIGHT}
                  checked={
                    dispatchStatusValue ===
                    Lang.LBL_FIRE_DISPATCH_STATUS_IN_FLIGHT
                  }
                  onChange={() =>
                    handleStatus(Lang.LBL_FIRE_DISPATCH_STATUS_IN_FLIGHT)
                  }
                />
              </ATMForm.Field>
              <ATMForm.Field>
                <ATMRadio
                  label={Lang.LBL_FIRE_DISPATCH_STATUS_LANDED}
                  value={Lang.LBL_FIRE_DISPATCH_STATUS_LANDED}
                  checked={
                    dispatchStatusValue === Lang.LBL_FIRE_DISPATCH_STATUS_LANDED
                  }
                  onChange={() =>
                    handleStatus(Lang.LBL_FIRE_DISPATCH_STATUS_LANDED)
                  }
                />
              </ATMForm.Field>
              <ATMForm.Field>
                <ATMRadio
                  label={Lang.LBL_FIRE_DISPATCH_STATUS_CANCELLED}
                  value={Lang.LBL_FIRE_DISPATCH_STATUS_CANCELLED}
                  checked={
                    dispatchStatusValue ===
                    Lang.LBL_FIRE_DISPATCH_STATUS_CANCELLED
                  }
                  onChange={() =>
                    handleStatus(Lang.LBL_FIRE_DISPATCH_STATUS_CANCELLED)
                  }
                />
              </ATMForm.Field>
              <ATMForm.Field>
                <ATMRadio
                  label={Lang.LBL_FIRE_DISPATCH_STATUS_COMPLETED}
                  value={Lang.LBL_FIRE_DISPATCH_STATUS_COMPLETED}
                  checked={
                    dispatchStatusValue ===
                    Lang.LBL_FIRE_DISPATCH_STATUS_COMPLETED
                  }
                  onChange={() =>
                    handleStatus(Lang.LBL_FIRE_DISPATCH_STATUS_COMPLETED)
                  }
                />
              </ATMForm.Field>
            </ATMForm.Group>
          </ATMGrid.Column>
        </ATMGrid.Row>
        <ATMGrid.Row>
          <ATMGrid.Column>
            <ATMField
              name="reason"
              width={12}
              label={Lang.LBL_FIRE_DISPATCH_REASON_COMMENTS}
              as={ATMForm.TextArea}
              control={control}
            />
          </ATMGrid.Column>
        </ATMGrid.Row>
      </ATMGrid>
    </ATMSegment>
  );
};

export default FireDispatchStatusForm;
